import axios from "axios";

const API_BASE_URL = "https://api.scoriva.net/api";

const api = axios.create({
    baseURL: API_BASE_URL,
});

export const newsApi = {
    getAll: () => api.get("/news"),

    getById: (id) => api.get(`/news/${id}`),

    getImageUrl: (id) => `${API_BASE_URL}/news/${id}/image`,

    create: (payload) => {
        const fd = new FormData();

        fd.append("TitleAz", payload.titleAz ?? "");
        fd.append("TitleEn", payload.titleEn ?? "");
        fd.append("TitleRu", payload.titleRu ?? "");

        fd.append("ContentAz", payload.contentAz ?? "");
        fd.append("ContentEn", payload.contentEn ?? "");
        fd.append("ContentRu", payload.contentRu ?? "");

        fd.append("YoutubeLink", payload.youtubeLink ?? "");

        if (payload.manualInsertedDate) {
            fd.append(
                "ManualInsertedDate",
                new Date(payload.manualInsertedDate).toISOString()
            );
        }

        if (payload.imageFile) {
            fd.append("ImageFile", payload.imageFile);
        }

        return api.post("/news", fd, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    update: (id, payload) => {
        const fd = new FormData();

        if (payload.titleAz !== undefined) {
            fd.append("TitleAz", payload.titleAz ?? "");
        }

        if (payload.titleEn !== undefined) {
            fd.append("TitleEn", payload.titleEn ?? "");
        }

        if (payload.titleRu !== undefined) {
            fd.append("TitleRu", payload.titleRu ?? "");
        }

        if (payload.contentAz !== undefined) {
            fd.append("ContentAz", payload.contentAz ?? "");
        }

        if (payload.contentEn !== undefined) {
            fd.append("ContentEn", payload.contentEn ?? "");
        }

        if (payload.contentRu !== undefined) {
            fd.append("ContentRu", payload.contentRu ?? "");
        }

        if (payload.youtubeLink !== undefined) {
            fd.append("YoutubeLink", payload.youtubeLink ?? "");
        }

        if (payload.manualInsertedDate !== undefined) {
            fd.append(
                "ManualInsertedDate",
                payload.manualInsertedDate
                    ? new Date(payload.manualInsertedDate).toISOString()
                    : ""
            );
        }

        if (payload.imageFile) {
            fd.append("ImageFile", payload.imageFile);
        }

        return api.put(`/news/${id}`, fd, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    remove: (id) => api.delete(`/news/${id}`),
};